import React, { useEffect, useMemo, useState } from 'react';
const CartIdContext = React.createContext({
    cartId: null,
    setCartId: undefined
});
function CartIdProvider(props) {
    let persistedCartId = null;
    try {
        persistedCartId = localStorage.getItem('cartId') || null;
    }
    catch (e) { }
    // We have swapped from using cookies for cartID to using localStorage.
    // This converts any cookies to the new format, then deletes the cookie.
    // TODO: Delete this after ~ April 06
    const convertedCartID = useCookieConversion(persistedCartId);
    persistedCartId = convertedCartID || persistedCartId;
    const [cartId, setCartId] = useState(persistedCartId);
    useEffect(() => {
        try {
            if (cartId) {
                localStorage.setItem('cartId', cartId);
            }
            else {
                localStorage.removeItem('cartId');
            }
        }
        catch (e) {
            // No local storage
            console.log(e);
        }
    }, [cartId]);
    const value = useMemo(() => {
        return {
            cartId,
            setCartId
        };
    }, [cartId, setCartId]);
    return (React.createElement(CartIdContext.Provider, { value: value }, props.children));
}
// Set the cookie to expire in the past, effectively deleting it.
function deleteCartIdCookie() {
    document.cookie = 'cartId=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
function useCookieConversion(cartId) {
    // We already have an id or this is SSR land, don't do anything
    if (cartId || !document || !localStorage) {
        return;
    }
    // Stolen from https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
    const cartIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)cartId\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    if (cartIdCookie) {
        deleteCartIdCookie();
        return cartIdCookie;
    }
    else {
        return null;
    }
}
export { CartIdProvider, CartIdContext };
//# sourceMappingURL=CartIdContext.js.map